import { helmetTypes } from '../utils/dummyData';

const SET_CURRENT_CATEGORY = 'SET_CURRENT_CATEGORY';
const SET_SHOW_SIDE_PANE = 'SET_SHOW_SIDE_PANE';
const SET_IS_LOADING = 'SET_IS_LOADING';
const SET_IS_DASHBOARD_OPEN = 'COMMON/SET_IS_DASHBOARD_OPEN';
const SET_IS_CONFIG_SAVED = 'SET_IS_CONFIG_SAVED';
const SET_SNACKBAR = 'SET_SNACKBAR';

const initialState = {
  currentCategory: 'helmetType',
  data: helmetTypes,
  shouldShowSidePane: false,
  isDashboardOpen: false,
  isLoading: false,
  isConfigSaved: false,
  snackbar: {
    isOpen: false,
    text: ''
  }
};

export const setCurrentCategory = (currentCategory, data) => {
  return {
    type: SET_CURRENT_CATEGORY,
    currentCategory,
    data
  };
};

export const setSnackbar = data => ({
  type: SET_SNACKBAR,
  data
});

export const setIsDashboardOpen = bool => {
  return {
    type: SET_IS_DASHBOARD_OPEN,
    bool
  };
};
export const setIsConfigSaved = bool => {
  return {
    type: SET_IS_CONFIG_SAVED,
    bool
  };
};

export const setShouldShowSidePane = bool => {
  return {
    type: SET_SHOW_SIDE_PANE,
    bool
  };
};

export const setIsLoading = value => ({ type: SET_IS_LOADING, value });

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SNACKBAR:
      return { ...state, snackbar: action.data };
    case SET_CURRENT_CATEGORY:
      return {
        ...state,
        currentCategory: action.currentCategory,
        data: action.data
      };
    case SET_SHOW_SIDE_PANE:
      return {
        ...state,
        shouldShowSidePane: action.bool
      };
    case SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.value
      };
    case SET_IS_CONFIG_SAVED:
      return {
        ...state,
        isConfigSaved: action.bool
      };
    case SET_IS_DASHBOARD_OPEN:
      return {
        ...state,
        isDashboardOpen: action.bool
      };
    default:
      return state;
  }
};
